<template>
  <v-btn 
    :class="[{'btnNormal': !outlined, 'btnOutlined': outlined}]" 
    :color="color"
    :style="{backgroundColor: showBgColor(color)}"
    :outlined="outlined"
    :disabled="disabled"
    elevation="0"
    @click="$emit('click')" 
  >
    <v-icon v-if="icon" :color="textColor" class="pr-2" size="14">
      {{icon}}
    </v-icon>
    <span :class="[`${showClassColor(textColor)}`, 'letter-spacing']" :style="`${showStyleColor(textColor)}; font-size: ${textSize};`">
      {{label}}
    </span>
  </v-btn>
</template>

<script>
  export default {
    props: {
      label: {type: String, default: 'Botão'},
      outlined: {type: Boolean, default: false},
      color: {type: String, default: 'bt_color' },
      textColor: {type: String, default: 'white'},
      textSize: {type: String, default: '0.85rem'},
      icon: {type: String},
      disabled: {type: Boolean, default: false}
    },

    computed: {
      outlinedBorderColor () {
        return `1px solid #0067AF !important`
      }
    },

    methods: {
      showClassColor (color) {
        if (color && !color.includes('#') && !color.includes('rgb')) return `${color}--text`
        else return ''
      },

      showStyleColor (color) {
        if (color && (color.includes('#') || color.includes('rgb'))) return `color: ${color} !important`
        else return ''        
      },

      showBgColor (color) {
        if (color && (color.includes('#') || color.includes('rgb'))) return `${color} !important`
        else return null        
      }
    }
  }
</script>

<style scoped>
.btnNormal {
  text-transform: none !important;
  height: 36px !important;
  border-radius: 56px !important;
  padding: 0px 16px !important;
  color: white !important;
}

.btnOutlined {
  margin: 0px;
  text-transform: none;
  background-color: transparent !important;
  box-sizing: border-box !important;
  border-radius: 56px !important;
  height: 36px !important;
  padding: 0px 16px !important;
}

.letter-spacing {
  letter-spacing: 0.05rem;
}
</style>
